// Ratios 0, 0.01 … 0.6: a text taller than the screen never reaches 0.6, so
// the observer has to report on the way there for isTextInView to see it.
export const IN_VIEW_THRESHOLDS = Array.from({ length: 61 }, (_, i) => i / 100);

/**
 * A text starts animating once 60% of it is on screen, or, when it is too
 * tall for that, once it fills 60% of the screen. With the ratio alone a long
 * text (a pasted article) stayed at its base opacity forever.
 */
export const isTextInView = (
  entry: Pick<
    IntersectionObserverEntry,
    "intersectionRatio" | "intersectionRect" | "rootBounds"
  >,
): boolean =>
  entry.intersectionRatio >= 0.6 ||
  entry.intersectionRect.height >=
    0.6 * (entry.rootBounds?.height ?? window.innerHeight);
